<template>
    <CraftLink
        :link="item?.linkField"
        class="segmentation-card"
    >
        <div class="segmentation-card__image">
            <BaseImage
                :image="item?.image?.[0]"
                :alt="item?.image?.[0]?.title"
                sizes="(min-width: 900px) 95vw, 600px"
            />
        </div>

        <div
            v-if="item?.linkField.title"
            class="segmentation-card__title"
        >
            {{ item?.linkField.title }}
        </div>
        <div
            v-else
            class="segmentation-card__title"
        >
            {{ item?.linkField.customText }}
        </div>
    </CraftLink>
</template>

<script setup>
defineProps({
    item: {
        type: Object,
        default: () => {}
    },
    link: {
        type: [Object, String],
        required: false,
        default: () => null
    }
});
</script>

<style lang="less">
a.segmentation-card {
    .texture-grain();
    display: flex;
    padding: 1rem;
    gap: 1rem;
    flex-direction: column;
    justify-content: center;
    background-color: white;
    text-decoration: none;

    transition: background 0.3s ease;

    &:hover {
        text-decoration: none;
        background-color: var(--color-cream);
    }
}

.segmentation-card__title {
    .typography-label();
    text-align: center;
}

.segmentation-card__image {
    position: relative;
    width: 100%;
    aspect-ratio: 4 / 3;
    overflow: hidden;

    figure {
        height: 100%;
    }

    picture {
        display: block;
        height: 100%;
    }

    img {
        .img-responsive();

        height: 100%;
        object-fit: cover;
    }
}
</style>
